import React from 'react';
import {SPECS} from '../../../../../common/constants';
import {useExperiments, useEnvironment} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {Totals} from '../../../../../common/components/Totals/Totals';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {getTaxesWithSomeTaxExemption} from '../../../../../domain/utils/total.util';
import {TaxModel} from '../../../../../domain/models/checkout/CartSummary/Tax.model';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';
import {getTaxTitle, getTaxValue} from './Tax.utils';
import {classes} from '../../../../../common/components/Totals/Partials/TotalsRow/TotalsRow.st.css';

export const TaxTotalsRow = () => {
  const {cart, cartSummary, isCartSummaryUpdating} = useControllerProps().checkoutStore;
  const {checkoutSettings} = useControllerProps().checkoutSettingsStore;
  const {experiments} = useExperiments();
  const {isRTL} = useEnvironment();
  const localeKeys = useLocaleKeys();
  const taxIncludedInPrice = cart.taxInfo.pricesIncludeTax;
  const addExemptTextToTaxNameWhenPartiallyExempt = experiments.enabled(
    SPECS.AddExemptTextToTaxNameWhenPartiallyExempt
  );

  const getTaxRowsToDisplay = () => {
    if (taxIncludedInPrice) {
      return getTaxesWithSomeTaxExemption(cartSummary!.taxSummary.taxes);
    } else {
      return cartSummary!.taxSummary.taxes;
    }
  };

  const taxRowsToDisplay = getTaxRowsToDisplay();

  if (taxRowsToDisplay.length === 0 || !checkoutSettings.isTaxConfigured) {
    return null;
  }

  const getTaxValueOrSkeleton = (tax: TaxModel) => {
    return isCartSummaryUpdating
      ? () => <TotalUpdateSkeleton />
      : getTaxValue({
          tax,
          isTaxIncludedInPrice: !!taxIncludedInPrice,
          isRTL,
          localeKeys,
        });
  };

  if (taxRowsToDisplay.length === 1) {
    const tax = taxRowsToDisplay[0];
    return (
      <Totals.TotalsRow
        dataHook={TotalsSectionDataHooks.TaxRow}
        title={getTaxTitle({
          tax,
          localeKeys,
          addExemptTextToTaxNameWhenPartiallyExempt,
        })}
        value={getTaxValueOrSkeleton(tax)}
      />
    );
  }

  return (
    <Totals.TotalsSection
      title={localeKeys.checkout.order_summary.totals.tax()}
      dataHook={TotalsSectionDataHooks.TaxSection}>
      {taxRowsToDisplay.map((tax, index) => (
        <Totals.TotalsRow
          className={classes.groupedRow}
          isSecondary={true}
          dataHook={TotalsSectionDataHooks.TaxRow}
          key={index}
          title={getTaxTitle({
            tax,
            localeKeys,
            addExemptTextToTaxNameWhenPartiallyExempt,
          })}
          value={getTaxValueOrSkeleton(tax)}
        />
      ))}
    </Totals.TotalsSection>
  );
};
